export default __webpack_public_path__ + "static/caption-02-en-e0891dda1bbf70787f79dc2e820ec26a.png";